import Modal from "../components/modal";
import react from 'react';

export default class DefineFieldGeometryModal extends react.Component {
  constructor(props) {
    super(props);

    this.state = { 
      show: props.show,
      hideAction: props.hideAction,
    };

    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside() {
    this?.state?.hideAction && this?.state.hideAction();
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ show: nextProps.show });  
  }

  render() {
    return (
      <>
        <Modal show = {this.state.show} header = { "Define field geometry" } hideAction = {this.state.hideAction}>
          <h3 className="h4-font-size subheading">Draw a field</h3>
          <p>Click on the <span className="btn btn-outline-secondary btn-sm"><i className="icon icon-vector-square pr-2" />Field</span> to draw your field on the map.</p>
          <div className="alert alert-info alert-outline d-flex">
            <div className="alert-icon">
              <div className="icon icon-info-circle pt-1 pr-3" />
            </div>
            <div className="alert-message">
              <p>Concave shapes can lead to very inefficient route.</p>
              <div className="d-flex">
                <img src="../info-convex.png" alt="Convex shape" className="pr-6" />
                <img src="../info-notConvex.png" alt="Concave shape" />
              </div>
            </div>
          </div>
        </Modal>
      </>
    );
  }
};